import $ from 'jquery';
import { setupStopReferrerHack } from './stop-referrer-hack.ts';
import { setupNavigation } from './navigation.ts';
import { setupCarousels } from './carousels.ts';
import { setupFormValidation } from './form-validation.ts';
import { setupSiteInteractions } from './site-interactions.ts';
import { setupFanchoice } from './fanchoice.ts';

export const setupDocumentReady = (): void => {
  $(() => {
    setupStopReferrerHack();
    setupNavigation();
    setupCarousels();
    setupFormValidation();
    setupSiteInteractions();
    setupFanchoice();
  });
};
